export default __webpack_public_path__ + "static/media/studentRealCase1-sc.cd5277d0.jpg";